const BASE_URL_DEV = "https://localhost:5001/";
const BASE_URL_PROD = "https://api.gpfaportal.com/";
export const AppConfigConstant = {
  API_URL :  process.env.NODE_ENV === 'development' ? BASE_URL_DEV : BASE_URL_PROD
};